/**
 * index.tsx
 * [Readme] --------------------------------------------------------------------------------------
 * 
 * 데스크탑에서 GNB 헤더 바로 아래의 영역을 렌더링 하는 컴포넌트입니다.
 * 서버로부터 기본 분양 정보, 메인 이미지등을 전달 받고 이를 렌더링합니다.
 * 
 * -----------------------------------------------------------------------------------------------
 */

import './Header.scss';

import React from 'react';
import InterestPopup from 'common-modules/general/Common/Components/Popup/desktop/InterestPopup';
import { downloadList } from 'data/downloads';
import { observer, useLocalObservable } from 'mobx-react';
import WatchListModel from 'common-modules/general/Common/Logic/WatchList/WatchListCommon';
import { useEffect } from 'react';
import { toJS } from 'mobx';
import { RequestEditWatchList, ResponseWatchlist, YnAgreeModel } from 'common-modules/general/API/watchlist/types';
import { cdPrgsStat } from 'common-modules/general/API/main/types';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';
import { RoutesString } from 'common-modules/general/Config/routesString';
import useStore from 'common-modules/general/Store/MobxStore';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import MobileFallbackImage from '../../../../assets/common/bg_visual_default_pc.png';
import TabMenu from '../TabMenu';
import RedirectHelper from 'common-modules/general/Model/RedirectHelper';
import { useHistory } from 'react-router';
import SimplePopup from 'common-modules/general/Common/Components/Popup/desktop/SimplePopup';
import MobxStore from 'common-modules/general/Store/MobxStore';

interface Props {
  mainModel: MainModel;
}

const SalesHeader = observer(({ mainModel }: Props) => {
  const { toaster } = MobxStore();
  const history = useHistory();
  const url = window.location.href;
  const [openShare, setIsOpenShare] = React.useState(false);
  const [dataCheck, setDataCheck] = React.useState<ResponseWatchlist[] | null>(null);
  const [isOpenInterestPopup, setIsOpenInterestPopup] = React.useState(false);
  const [isOpenCompleteModal, setIsOpenCompleteModal] = React.useState(false);
  const [isOpenSuccessInterest, setIsOpenSuccessInterest] = React.useState(false);
  const [imageLoaded, setImageLoaded] = React.useState<boolean>(false);
  const [agree, setAgree] = React.useState<YnAgreeModel | null>(null);

  const { model: watchListModel } = useLocalObservable(() => ({ model: new WatchListModel() }));

  const {
    authManager: { userData }
  } = useStore();
  const redirectHelper = new RedirectHelper();

  const handleClickInterestPopup = () => {
    if (!userData) {
      const isDiffOrigin = RoutesString.Login.includes('http');
      const path = isDiffOrigin ? window.location.href : history.location.pathname;

      redirectHelper.setPageRedirectData(path, isDiffOrigin ? 'diff' : 'same-origin');
      window.location.href = RoutesString.Login;

      return;
    } else {
      setAgree({
        agreeCheck: (userData.ynSmsRcpn == 'Y' || userData.ynEmailRcpn == 'Y'),
        ynSmsRcpn: false,
        ynEmailRcpn: false
      })
      setIsOpenInterestPopup(true);
    }
  };

  useEffect(() => {
    if (userData) {
      watchListModel.getData();
    }
  }, [userData]);

  useEffect(() => {
    if (watchListModel.mainData.data) {
      setDataCheck(toJS(watchListModel.mainData.data));
    }
  }, [watchListModel.mainData.data]);

  const handleClickCloseButton = () => {
    setDataCheck(toJS(watchListModel.mainData.data));
  };

  function share_band() {
    var infoPlen = document.title + ' ' + encodeURIComponent(url);

    // PC 버전
    var shareUrl = 'http://www.band.us/plugin/share?body=' + encodeURIComponent(infoPlen) + '&route=www.elife.co.kr';

    window.open(shareUrl, 'share_band', 'width=410, height=540, resizable=no');
    setIsOpenShare(false);

    // 모바일 버전
    //var param = 'create/post?text=' + encodeURIComponent(infoPlen) + "&route=www.elife.co.kr";
    //location.href = 'bandapp://' + param;
  }

  function kakaoSendLink() {
    Kakao.Link.sendScrap({
      requestUrl: url
    });
    setIsOpenShare(false);
  }

  const handleClickConfirmButton = () => {
    if (dataCheck) {
      const checkedList: RequestEditWatchList['watchList'] = [];

      dataCheck.forEach(item => {
        if (item.selected === 'Y') {
          checkedList.push({ infoPlen: item.infoPlen, infoPlenType: item.infoPlenType });
        }
      });

      if (checkedList.length === 0) {
        toaster.toast('관심 평형을 선택해 주세요.');

        return;
      } else {
        if (!agree?.agreeCheck) {
          const ynSmsRcpnTxt = agree?.ynSmsRcpn ? 'Y' : 'N';
          const ynEmailRcpnTxt = agree?.ynEmailRcpn ? 'Y' : 'N';

          const agreeParam = !agree?.agreeCheck ? {
            agreeCheck: agree?.agreeCheck ? 'Y' : 'N',
            ynSmsRcpn: ynSmsRcpnTxt,
            ynEmailRcpn: ynEmailRcpnTxt,
          } : {};
          watchListModel.editData(checkedList, 'P', agreeParam); // "P"값은 PC의 P
          setIsOpenSuccessInterest(true);
        } else {

          watchListModel.editData(checkedList, 'P'); // "P"값은 PC의 P
          setIsOpenCompleteModal(true);
        }
      }
    }
  };

  const salesInfo = toJS(mainModel.mainData.data);

  const getTagClassName = (tag: string) => {
    if (tag === '007' || tag === '002') {
      return 'tag-color-b';
    } else if (tag === '003') {
      return 'tag-color-b';
    } else if (tag === '004') {
      return 'tag-color-c';
    } else if (tag === '005') {
      return 'tag-color-d';
    } else {
      return 'tag-color-c';
    }
  };

  const renderPrgsStat = () => {
    if (salesInfo && salesInfo.cdPrgsStat && typeof salesInfo.cdPrgsStat !== 'string') {
      const sortCdPrgsStat = salesInfo.cdPrgsStat.sort();
      return sortCdPrgsStat.map(item => {
        return (
          <span key={item} className={`tag ${getTagClassName(item)}`}>
            {cdPrgsStat[item]}
          </span>
        );
      });
    } else {
      return null;
    }
  };

  const isRegisteredCustomer = () => {
    const isData = toJS(watchListModel.mainData.data)?.find(item => item.selected === 'Y');

    if (isData) {
      return isData.selected === 'Y';
    } else {
      return false;
    }
  };

  const cancelCompleteButton = () => {
    setIsOpenInterestPopup(false);
    setIsOpenCompleteModal(false);
    setIsOpenSuccessInterest(false);
  };

  const handlePageMoveInterest = () => {
    window.open(RoutesString.IntersetComplex, '_blank');
    cancelCompleteButton();
  };

  const getTextToday = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');

    const todayTxt = `${year}년 ${month}월 ${day}일`;
    return '디엘건설㈜ 마케팅 정보 수신 동의에 따라, 아래와 같이 수신 동의 및 관심고객 등록되었습니다.'
      + '<br>동의일 : ' + todayTxt;
  }

  return (
    <>
      <div className="sales-header">
        <div className="section-a full position-r content">
          <div className="ratio-keep-section main-movie">
            <div className="ratio-keep-container">
              <img
                className="ratio-keep-content"
                onLoad={() => setImageLoaded(true)}
                src={
                  salesInfo && !salesInfo.imgMainLnkPc
                    ? MobileFallbackImage
                    : `${APIClientBaseURL.file}${salesInfo?.imgMainLnkPc}`
                }
                alt=""></img>
            </div>
          </div>
          {imageLoaded && (
            <div className="public-main-visual-top">
              <div className="status">
                {/* 분양중, 분양완료와 같은 상태표 렌더링 */}
                {renderPrgsStat()}

                {/* 아래는 홍보 문구로 분양지마다 상이함 */}
                <span className="txt01">광주 교육 1번지에 No.1 브랜드를 더하다</span>
              </div>
              {/* <h2 className="main-txt">{salesInfo?.nmBizLnd}</h2> */}
              <h2 className="main-txt">e편한세상 봉선 셀레스티지</h2>
              <div className="btn-area">
                <div className="btn_box" onClick={handleClickInterestPopup}>
                  <button
                    className=" item-over-test ui-tooltip btn-util btn-util01 "
                    type="button"
                    data-position="bottom"
                    data-type="type01"
                    data-text="관심 단지로 등록되며 주요 알림과 추천을 합니다.">
                    {isRegisteredCustomer() ? (
                      <i className="ico-star-on" aria-hidden="true"></i>
                    ) : (
                      <i className="ico-star-off" aria-hidden="true"></i>
                    )}
                  </button>
                  <span className="btn_txt">관심고객 등록</span>
                </div>

                <div className="btn_box">
                  <button className="btn-util btn-util02" type="button" onClick={() => setIsOpenShare(!openShare)}>
                    <span className="ico-bg" aria-hidden="true"></span>
                    <span className="ico-share-off" aria-hidden="true"></span>
                  </button>
                  <div className="share-layer01" style={{ display: `${openShare ? 'block' : 'none'}` }}>
                    <div className="share-content">
                      {/* <div className="btn-share" onClick={kakaoSendLink}>
                        <i className="ico-kakao-talk" aria-hidden="true"></i>
                        <div className="hide-txt">카카오톡</div>
                      </div> */}
                      <a
                        className="btn-share"
                        target={'_blank'}
                        href={`https://story.kakao.com/share?url=${url}`}
                        onClick={() => setIsOpenShare(false)}
                        rel="noreferrer">
                        <i className="ico-kakao-story" aria-hidden="true"></i>
                        <div className="hide-txt">카카오스토리</div>
                      </a>
                      <a
                        className="btn-share"
                        target={'_blank'}
                        href={`https://twitter.com/intent/tweet?text=${url}&source=webclient`}
                        onClick={() => setIsOpenShare(false)}
                        rel="noreferrer">
                        <i className="ico-twitter" aria-hidden="true"></i>
                        <div className="hide-txt">트위터</div>
                      </a>
                      <a
                        className="btn-share"
                        target={'_blank'}
                        href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                        onClick={() => setIsOpenShare(false)}
                        rel="noreferrer">
                        <i className="ico-facebook" aria-hidden="true"></i>
                        <div className="hide-txt">페이스북</div>
                      </a>
                      <a
                        className="btn-share"
                        onClick={() => {
                          share_band();
                        }}>
                        <i className="ico-band" aria-hidden="true"></i>
                        <div className="hide-txt">네이버 밴드</div>
                      </a>
                    </div>
                  </div>
                  <span className="btn_txt">SNS 공유</span>
                </div>
                <div className="info-txt">분양상담 {salesInfo?.cntsBiz}</div>
              </div>
            </div>
          )}
          {/* 다운로드 링크 리스트 */}
          <div className="public-main-visual-bottom">
            {downloadList &&
              downloadList.map(item => (
                <a key={item.title} href={item.link} className="btn-down" target="_blank">
                  <i className="ico-down"></i>
                  <span className="btn_txt">{item.title}</span>
                </a>
              ))}
          </div>

          {/* 상기 일러스트 문구 */}
          <span className="guide-txt">
            * 상기 일러스트는 소비자의 이해를 돕기 위해 제작된 것으로 실제와 차이가 있을 수 있습니다.
          </span>
        </div>
      </div>

      {dataCheck && agree && (
        <InterestPopup
          onClickConfirmButton={handleClickConfirmButton}
          setDataCheck={setDataCheck}
          dataCheck={dataCheck}
          isOpen={isOpenInterestPopup}
          setIsOpenInterestPopup={setIsOpenInterestPopup}
          onClickCloseButton={handleClickCloseButton}
          agree={agree}
          setAgree={setAgree}
        />
      )}

      {/* 개요, 분양, 사이버 주택전시관등의 소메뉴가 있는 탭입니다. */}
      {imageLoaded && <TabMenu mainModel={mainModel} />}

      <SimplePopup
        onConfirmButtonClick={handlePageMoveInterest}
        onCancelButtonClick={cancelCompleteButton}
        open={isOpenCompleteModal}
        title="등록이 완료되었습니다."
        confirmButtonTxt="이동">
        <div>
          등록하신 관심 단지를 보시려면 <br /> 이동을 눌러주세요.
        </div>
      </SimplePopup>

      <SimplePopup
        isSingleButton
        onCancelButtonClick={cancelCompleteButton}
        open={isOpenSuccessInterest}
        title="관심고객 등록 및 마케팅 수신동의 처리결과"
      >
        <div dangerouslySetInnerHTML={{ __html: getTextToday() }} />
      </SimplePopup>
    </>
  );
});

export default SalesHeader;
